import CryptoJS from "crypto-js";

const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_JS_ENCRYPTION_KEY);
const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_JS_ENCRYPTION_IV);

export const encryptPayload = (payload) =>{
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(payload), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  const encryptedBase64 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

  return encryptedBase64;
}
